import { IconV2 } from 'components/common/IconV2/IconV2';
import type { MediumIconV2Props } from 'components/common/IconV2/IconV2.types';

const UserIcon = (props: MediumIconV2Props) => (
  <IconV2 {...props} viewBox="0 0 32 32">
    <path
      stroke="currentcolor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="M16 16a3.754 3.754 0 0 1-3.75-3.75A3.754 3.754 0 0 1 16 8.5a3.754 3.754 0 0 1 3.75 3.75A3.754 3.754 0 0 1 16 16M8.999 25.09l.002-.018a7.031 7.031 0 0 1 13.998 0"
    />
    <circle cx="16.001" cy="16.001" r="11.53" stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" />
  </IconV2>
);

export default UserIcon;
